export default __webpack_public_path__ + "static/ip-protection-for-2dfb65a485bd51f91d9c39f440db700c.png";